import React from 'react';
import axios from 'axios';
import hyperid from 'hyperid';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik, Field, Form } from 'formik';
import { camelCase } from 'change-case';
import md5 from 'md5';
import QrReader from 'react-qr-reader';

import { processQuestionsAnswers } from '../../utils';
import '../../App.css';
import Store from '../../store';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

const questionTypes = {
  TEXT: 0,
  RADIOBUTTON: 1,
  NUMBER: 2,
  NONRESPONSE: 4,
};
const GeneralQuestionnaire = (props) => {
  if (props.selectedVisitorType === undefined) {
    return null;
  }

  if (props.questions.length === 0) {
    return null;
  }

  props.questions.map((question, index) => {
    if (question.label === 'Where are you from?') {
      props.questions.splice(index, 1);
    }
    return true;
  });

  if (props.pagination) {
    return (
      <div>
        {props.questions.map((question, index) => {
          if (index % 2 === 0) {
            let hashedLabelTwo, inputNameTwo, inputPropsTwo;
            const hashedLabel = md5(camelCase(question.label), {
              algorithm: 'md5',
            });

            const inputName = `question_inputN_${question.inputN}_${hashedLabel}`;

            const inputProps = {
              inputName,
              ...question,
              ...props,
            };

            let questionTwo = props.questions[index + 1];
            if (questionTwo) {
              hashedLabelTwo = md5(camelCase(questionTwo.label), {
                algorithm: 'md5',
              });

              inputNameTwo = `question_inputN_${questionTwo.inputN}_${hashedLabelTwo}`;

              inputPropsTwo = {
                inputNameTwo,
                ...questionTwo,
                ...props,
              };
            }
            return (
              <div id={2 + Math.round(index / 2)} className={'questionPart'}>
                <p className="text-lg text-white">Questionnaire</p>
                <p className="text-white mt-1 mb-2 text-xs italic">Please answer the questionnaire below:</p>
                <hr className="mt-2 mb-2" />
                <GeneralQuestionnaire.Input key={inputName} {...inputProps} />
                <GeneralQuestionnaire.Input key={inputNameTwo} {...inputPropsTwo} />
              </div>
            );
          }
          return '';
        })}
      </div>
    );
  }
  return (
    <div>
      <p className="text-lg text-white">Questionnaire</p>
      <p className="text-white mt-1 mb-2 text-xs italic">Please answer the questionnaire below:</p>
      <hr className="mt-2 mb-2" />

      {props.questions.map((question) => {
        const hashedLabel = md5(camelCase(question.label), {
          algorithm: 'md5',
        });

        const inputName = `question_inputN_${question.inputN}_${hashedLabel}`;

        const inputProps = {
          inputName,
          ...question,
          ...props,
        };
        return <GeneralQuestionnaire.Input key={inputName} {...inputProps} />;
      })}
    </div>
  );
};

GeneralQuestionnaire.Input = (props) => {
  if (props.type === questionTypes.TEXT) {
    return (
      <div className="mb-4">
        <label className="block text-white text-sm font-bold mb-2" htmlFor={props.inputName}>
          {props.label}
        </label>
        <Field
          className={`shadow appearance-none border w-full py-2 px-3 mb-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ${
            props.errors[props.inputName] ? 'border-red-500' : ''
          }`}
          id={props.inputName}
          name={props.inputName}
          type="text"
          placeholder={props.placeholder}
          onChange={props.onChange}
          value={props.values[props.inputName]}
        />
        {props.errors[props.inputName] ? <p className="text-red-500 text-xs italic">{props.errors[props.inputName]}</p> : null}
      </div>
    );
  }
  if (props.type === questionTypes.RADIOBUTTON) {
    const onRadioButtonChange = (name, state) => {
      props.values[name] = state;
    };
    return (
      <div className="mb-4">
        <p className="text-white">{props.label}</p>
        <div className="text-white px-4 py-2">
          <fieldset>
            <input
              className={`mr-2 ${props.errors[props.inputName] ? 'border-red-500' : ''}`}
              type="radio"
              id={'Y' + props.inputName}
              name={props.inputName}
              onChange={() => onRadioButtonChange(props.inputName, true)}
            />
            <label htmlFor={'Y' + props.inputName}>Yes</label>
            <input className="mr-2 ml-4" type="radio" id={'N' + props.inputName} name={props.inputName} onChange={() => onRadioButtonChange(props.inputName, false)} />
            <label htmlFor={'N' + props.inputName}>No</label>
          </fieldset>
          {props.errors[props.inputName] ? <p className="text-red-500 text-xs italic">{props.errors[props.inputName]}</p> : null}
        </div>
      </div>
    );
  }

  if (props.type === questionTypes.NUMBER) {
    return (
      <div className="mb-4">
        <label className="block text-white text-sm font-bold mb-2" htmlFor={props.inputName}>
          {props.label}
        </label>
        <input
          className={`shadow appearance-none border w-full py-2 px-3 mb-3 text-white leading-tight focus:outline-none focus:shadow-outline ${
            props.errors[props.inputName] ? 'border-red-500' : ''
          }`}
          id={props.inputName}
          name={props.inputName}
          type="number"
          step="0.1"
          placeholder={props.placeholder}
          onChange={props.onChange}
          value={props.values[props.inputName]}
        />
        {props.errors[props.inputName] ? <p className="text-red-500 text-xs italic">{props.errors[props.inputName]}</p> : null}
      </div>
    );
  }

  if (props.type === questionTypes.NONRESPONSE) {
    return (
      <div className="mb-4 text-white">
        <p>{props.label}</p>
      </div>
    );
  }

  return null;
};

class QRCodePage extends React.Component {
  constructor(props) {
    super(props);

    const parsedQueryString = queryString.parse(window.location.search);
    this.siteId = parseInt(parsedQueryString.siteId, 10);
    this.employeeId = parseInt(parsedQueryString.employeeId, 10);

    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    this.state = {
      hosts: [],
      suggestedHosts: [],
      selectedHost: '',
      selectedHostDetails: undefined,
      selectedVisitorType: {
        template: undefined,
        typeId: undefined,
      },
      filteredQuestions: [],
      initialValues: {
        entryType: '',
      },
      userName: '',
      isResultModal: false,
      selectedStage: 0,
      paginationMax: 1,
      qrCodeData: false,
    };
    this.answersMap = new Map();
    this.instance = hyperid();
    this.formData = new FormData();

    this.formData.set('template', undefined);
    this.formData.set('typeId', undefined);
    this.formData.set('siteId', this.siteId);
    this.formData.set('accountId', -1);
  }

  async componentDidMount() {
    this.session = await this.initSession();
    this.site = await this.initSiteDetails();
    this.host = await this.initHost();

    const enabledVisitorTypes = this.site.visitorTypes.filter((v) => v.state === true);
    this.setState({
      site: this.site,
      hosts: this.host.data.employees,
      suggestedHosts: this.host.data.employees,
      visitorTypes: enabledVisitorTypes,
    });
  }

  async initSession() {
    const id = this.instance.uuid;
    await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: this.siteId,
    });
    const login = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/login`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: this.siteId,
    });
    return login.data;
  }

  initHost() {
    return axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/host?siteId=${this.siteId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });
  }

  async initSiteDetails() {
    const { data } = await axios.get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/${this.siteId}`, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });
    return data.site;
  }

  getSuggestions = (value) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0 ? [] : this.state.hosts.filter((host) => host.name.toLowerCase().slice(0, inputLength) === inputValue);
  };

  handleEntryTypeChange = async (setFieldValue, flag, entryType) => {
    this.answersMap.clear();
    const value = entryType;
    const [visitorType] = this.state.visitorTypes.filter((v) => {
      return v.name === value;
    });

    if (visitorType !== undefined) {
      const updatedQuestions = this.state.site.questions.map((q) => {
        const hashedLabel = md5(camelCase(q.label), {
          algorithm: 'md5',
        });
        q.inputName = `question_inputN_${q.inputN}_${hashedLabel}`;
        return q;
      });
      const filteredQuestions = updatedQuestions.filter((q) => q.visitorTypes.includes(visitorType.roleId));
      const initialValues = this.state.initialValues;
      filteredQuestions.forEach((q) => {
        if (q.type === questionTypes.TEXT) {
          initialValues[q.inputName] = '';
        }

        if (q.type === questionTypes.RADIOBUTTON) {
          initialValues[q.inputName] = this?.state?.site?.mandatoryAnswersToQuestions === false ? false : null;
        }

        if (q.type === questionTypes.NUMBER) {
          initialValues[q.inputName] = this?.state?.site?.mandatoryAnswersToQuestions === false ? 0 : null;
        }
      });

      this.setState({
        filteredQuestions,
        selectedVisitorType: visitorType,
        initialValues,
      });
      this.formData.set('typeId', visitorType.id);
      this.formData.set('roleId', visitorType.roleId);
      this.setState({
        paginationMax: 1 + Math.round(filteredQuestions.length / 2),
      });
    }
    await setFieldValue('entryType', value);
    if (flag) {
      document.getElementById(this.state.selectedStage).classList.remove('active');
      let selectPage = this.state.selectedStage + 1;
      this.setState({ selectedStage: selectPage });
      document.getElementById(selectPage.toString()).classList.add('active');
    }
  };

  handleFormSubmit = async (value) => {
    const values = { ...value, ...this.state.qrCodeData };

    for (const property in values) {
      this.formData.set(property, values[property]);

      if (property.includes('question_inputN_')) {
        this.answersMap.set(property, values[property]);
        this.formData.delete(property);
      }
    }

    this.setState({
      ...this.state,
      userName: this.state.qrCodeData.name,
    });

    if (this.state.filteredQuestions.length > 0) {
      const formattedAnswers = processQuestionsAnswers(this.answersMap, this.state.filteredQuestions);

      formattedAnswers.some((item) => {
        if (Number(item.answer) === item.notification && item.type === 1) {
          this.setState({
            ...this.state,
            isResultModal: true,
          });
          return true;
        }
        return false;
      });

      this.formData.set('answers', JSON.stringify(formattedAnswers));
    }

    this.formData.set('template', this.state.selectedVisitorType.template);
    this.formData.set('typeId', this.state.selectedVisitorType.id);
    this.formData.set('accountId', this.state.site.accountId);
    this.formData.set('employeeId', this.state.selectedHostDetails.id);

    const result = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/signin?siteId=${this.siteId}`, this.formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: this.session.id,
      },
    });

    if (result && result.data && result.data.visitorId) {
      Store.inviteCode = result.data.visitorId.inviteCode;
    }

    if (!this.state.isResultModal) {
      this.props.history.push('/temperature');
    }
  };

  buildValidationSchema = (questions) => {
    let visitorSignInSchema = Yup.object().shape({
      name: Yup.string().required('Your name is required'),
      mobilePhoneNumber: this.phoneValueScheme(),
      email: Yup.string().email().required('Your email address is required'),
      company: this.companyValueScheme(),
      nameOfHost: Yup.string().required('The host name you visit is required'),
      entryType: Yup.string().required('The entry type is required'),
    });

    if (questions.length === 0) {
      return visitorSignInSchema;
    }

    const questionsSchema = questions.map((q) => {
      if (q.type === questionTypes.RADIOBUTTON) {
        if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
          return [q.inputName, Yup.boolean().required('Please answer the question').nullable()];
        } else {
          return [q.inputName, Yup.boolean().nullable()];
        }
      }

      if (q.type === questionTypes.NUMBER) {
        if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
          return [q.inputName, Yup.number().required('Please answer the question').nullable()];
        } else {
          return [q.inputName, Yup.number().nullable()];
        }
      }
      if (this?.state?.site?.mandatoryAnswersToQuestions || this?.state?.site?.mandatoryAnswersToQuestions === undefined) {
        return [q.inputName, Yup.string().required('Please answer the question').nullable()];
      } else {
        return [q.inputName, Yup.string().nullable()];
      }
    });

    for (let i = 0; i < questions.length; i++) {
      visitorSignInSchema = Yup.object()
        .shape({
          name: Yup.string().required('Your name is required'),
          mobilePhoneNumber: this.phoneValueScheme(),
          email: Yup.string().email().required('Your email address is required'),
          company: this.companyValueScheme(),
          nameOfHost: Yup.string().required('The host name you visit is required'),
          entryType: Yup.string().required('The entry type is required'),
        })
        .shape(Object.fromEntries(questionsSchema));
    }

    return visitorSignInSchema;
  };

  companyValueScheme = () => {
    if (this?.state?.site?.mandatoryCompanyName && (this?.state?.site?.displayCompany || this?.state?.site?.displayCompany === undefined)) {
      return Yup.string().required('Your company name is required');
    }
    return Yup.string();
  };

  phoneValueScheme = () => {
    if (this?.state?.site?.mandatoryPhoneNumber) {
      return Yup.string().required('Your mobile phone is required').nullable();
    }
    return Yup.string().nullable();
  };

  onNextClick = () => {
    document.getElementById(this.state.selectedStage).classList.remove('active');
    let selectPage = this.state.selectedStage + 1;
    this.setState({ selectedStage: selectPage });
    document.getElementById(selectPage.toString()).classList.add('active');
  };

  onPrevClick = (resetQRData = false) => {
    document.getElementById(this.state.selectedStage).classList.remove('active');
    let selectPage = this.state.selectedStage - 1;
    this.setState({ selectedStage: selectPage });
    document.getElementById(selectPage.toString()).classList.add('active');
    if (resetQRData) {
      this.setState({
        qrCodeData: false,
      });
    }
  };

  handleScan = (setFieldValue, e) => {
    console.log('e', e);
    const dataJSON = e;
    if (dataJSON && this.validateQRCodeData(dataJSON)) {
      this.setState({
        qrCodeData: dataJSON,
      });
      this.handleEntryTypeChange(setFieldValue, true, dataJSON.entryType);
      setFieldValue('nameOfHost', dataJSON.nameOfHost);
      const [hostDetails] = this.state.hosts.filter((item) => item.name === dataJSON.nameOfHost);
      this.setState({
        selectedHost: dataJSON.nameOfHost,
        selectedHostDetails: hostDetails,
      });
    }
  };

  handleError = (err) => {
    console.error(err);
  };

  validateQRCodeData = (data) => {
    const requiredFields = ['name', 'mobilePhoneNumber', 'email', 'company', 'nameOfHost', 'entryType'];
    for (let i of requiredFields) {
      if (!data.hasOwnProperty(i)) {
        return false;
      }
    }
    return true;
  };

  render() {
    const { site, filteredQuestions, selectedVisitorType, initialValues } = this.state;

    if (site === undefined)
      return (
        <div className="container w-full max-w-xs mx-auto">
          <p className="text-center mt-4">Loading...</p>
        </div>
      );

    return (
      <div className="container w-full max-w-xs mx-auto">
        <Formik initialValues={initialValues} onSubmit={this.handleFormSubmit}>
          {({ errors, touched, values, handleChange, handleBlur, setFieldValue, isSubmitting }) => {
            if (this?.state?.site?.pagination) {
              return (
                <Form className="bg-blue-gradient shadow-md pt-6 pb-8 mb-4">
                  <div id={0} className={'questionPart active'}>
                    {!this.state.qrCodeData && (
                      <QrReader className="h-full w-full qrCodeWindow" delay={1000} onScan={this.handleScan.bind(this, setFieldValue)} onError={this.errorHandler} />
                    )}
                    <br />
                    <h2 className="text-center text-white text-3xl  font-extrabold">Scan your</h2>
                    <h1 className="text-center text-white text-4xl  font-extrabold">QR Code</h1>
                  </div>

                  <div id={1} className={'questionPart'}>
                    <div className="px-8 pt-6 pb-8 mb-4">
                      <img className="visitor-picture-preview" alt="" />
                      <div className={'description'}>
                        <div className={'descriptionBlock'}>
                          <div className={'descriptionTitle'}>I am</div>
                          <div className={'descriptionValue'}>{this.state.qrCodeData?.entryType}</div>
                        </div>
                        <div className={'descriptionBlock'}>
                          <div className={'descriptionTitle'}>My name is</div>
                          <div className={'descriptionValue'}>{this.state.qrCodeData?.name}</div>
                        </div>
                        <div className={'descriptionBlock'}>
                          <div className={'descriptionTitle'}>I am from</div>
                          <div className={'descriptionValue'}>{this.state.qrCodeData?.company}</div>
                        </div>
                        <div className={'descriptionBlock'}>
                          <div className={'descriptionTitle'}>Email</div>
                          <div className={'descriptionValue'}>{this.state.qrCodeData?.email}</div>
                        </div>
                        <div className={'descriptionBlock'}>
                          <div className={'descriptionTitle'}>Mobile</div>
                          <div className={'descriptionValue'}>{this.state.qrCodeData?.mobilePhoneNumber}</div>
                        </div>
                      </div>
                      <div className={'confirmQuestion'}>
                        <div className={'confirmText'}>Are you visiting</div>
                        <div className={'confirmText'}>{this.state.qrCodeData?.nameOfHost}?</div>
                      </div>
                      <div className="flex items-center justify-between">
                        <div
                          onClick={() => this.onPrevClick(true)}
                          className={'buttonNo bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline'}
                        >
                          {'No'}
                        </div>
                        {this.state.filteredQuestions.length === 0 ? (
                          <button
                            type="submit"
                            value="Submit"
                            className="buttonYes bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                            disabled={isSubmitting}
                          >
                            {'Yes'}
                          </button>
                        ) : (
                          <div
                            className="buttonYes bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                            onClick={this.onNextClick}
                          >
                            {'Yes'}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="px-8">
                    <GeneralQuestionnaire
                      selectedVisitorType={selectedVisitorType}
                      onChange={handleChange}
                      filteredQuestions={filteredQuestions}
                      errors={errors}
                      touched={touched}
                      values={values}
                      pagination={this?.state?.site?.pagination}
                    />
                  </div>

                  <div className={'px-8 paginationButtons'}>
                    {this.state.selectedStage > 1 && this.state.selectedStage <= this.state.paginationMax && (
                      <div onClick={() => this.onPrevClick()} id={'buttonPrev'} className={'buttonPagination paginationPrev'}>
                        {'< Prev'}
                      </div>
                    )}
                    {this.state.selectedStage > 1 &&
                    this.state.selectedStage <= this.state.paginationMax && //Object.keys(errors).length !== 0 &&
                      (this.state.selectedStage === this.state.paginationMax ? (
                        <button
                          type="submit"
                          value="Submit"
                          className="buttonYes bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 focus:outline-none focus:shadow-outline"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                      ) : (
                        <div onClick={this.onNextClick} id={'buttonNext'} className={'buttonPagination paginationNext'}>
                          {'Next >'}
                        </div>
                      ))}
                  </div>
                </Form>
              );
            }
          }}
        </Formik>
        <p className="text-center text-gray-500 text-xs">&copy;2020 My Lobby. All rights reserved.</p>

        {this.state.isResultModal ? this.props.history.push('/rejected') : ''}
      </div>
    );
  }
}

const AppWithRouter = withRouter(QRCodePage);
export default AppWithRouter;
